const impressum = {
    start() {
        // startScreen();
    },

    close() {
        // stopScreen();
    }
};


export {
    impressum
}